import styled from 'styled-components';
import { rem } from 'polished';
import { InterestedBoxStyled } from '../InterestedBoxStyled';

export const InterestedBoxStyledAP = styled(InterestedBoxStyled)`
    .dealerShare {
        font-size: ${rem('12px')};

        &:hover,
        &:focus-visible {
            color: ${({ theme }) => theme.colors.primary};
            border-color: ${({ theme }) => theme.colors.primary};
        }
    }

    .reinsurance {
        color: ${({ theme }) => theme.colors.black};
        line-height: 1.5;
        font-size: ${rem('12px')};
        border-bottom: 1px solid ${({ theme }) => theme.colors.black};
    }

    .links-section > .legal-text {
        font-size: ${rem('10px')};
    }
`;
